import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardImg,
  CardTitle,
  Collapse,
  Col,
  Input,
  Label,
  Row,
  Spinner,
  Badge,
} from "reactstrap";
import ThemeOptionService from "../../../Services/QRCodeServices/QrThemeService/ThemeOptionService";
import toast from "react-hot-toast";

const ThemeOptionDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [editingKeys, setEditingKeys] = useState({});
  const [loading, setLoading] = useState(false);
  const [showNewKeyForm, setShowNewKeyForm] = useState(false);
  const [newKey, setNewKey] = useState({ key: "", description: "" });
  const [openAccordion, setOpenAccordion] = useState("");

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const response = await ThemeOptionService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  const handleDescriptionChange = (index, value) => {
    setData((prev) => ({
      ...prev,
      keys: prev.keys.map((item, i) =>
        i === index ? { ...item, description: value } : item
      ),
    }));
  };

  const handleSave = async (index) => {
    try {
      const keyToUpdate = data.keys[index];
      const payload = {
        // id: keyToUpdate.id,
        key: keyToUpdate.key,
        description: keyToUpdate.description,
        // themesOptionsId: +id,
      };

      await ThemeOptionService.updateKey(keyToUpdate.id,payload);
      toast.success("Key description updated successfully");

      // Exit editing mode
      setEditingKeys((prev) => ({
        ...prev,
        [index]: false,
      }));
    } catch (error) {
      console.log(error);
      toast.error("Failed to update key description");
    }
  };

  const handleCreateNewKey = async () => {
    if (!newKey.key.trim() || !newKey.description.trim()) {
      toast.error("Please fill in both key and description");
      return;
    }

    try {
      const payload = {
        key: newKey.key,
        description: newKey.description,
        themesOptionsId: +id,
      };

      const response = await ThemeOptionService.createKey(payload);
      toast.success("New key created successfully");

      // Add the new key to the local state
      setData((prev) => ({
        ...prev,
        keys: [...prev.keys, response],
      }));

      // Reset form
      setNewKey({ key: "", description: "" });
      setShowNewKeyForm(false);
    } catch (error) {
      console.log(error);
      toast.error("Failed to create new key");
    }
  };

  const handleCancelEdit = (index) => {
    // Revert changes by refetching data or keeping original values
    fetchDetail();
    setEditingKeys((prev) => ({
      ...prev,
      [index]: false,
    }));
  };

  const toggleAccordion = (target) => {
    setOpenAccordion(openAccordion === target ? "" : target);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Theme Option Detail"
          title={id ? "Edit Theme Option" : "Create Theme Option"}
          breadcrumbItems={[{ title: "Back To List", link: "/theme-option" }]}
        />
        <Row>
          <Col>
            <Card className="mb-4">
              {/* <CardImg src={data?.theme?.imageUrl?.getCDNUrl()} /> */}
              <CardBody>
                <div className="mb-3">
                  <h5 className="fw-bold">Title: </h5>
                  <h6 className="fw-normal">{data?.title}</h6>
                </div>
                <div>
                  <h5 className="fw-bold">Description: </h5>
                  <p className="text-muted">{data?.description}</p>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col>
            <Card>
              <CardBody>
                {/* Add New Key Button */}
                <div className="mb-2 align-content-end justify-content-between d-flex align-content-center">
                  <h5>Theme Option Key</h5>
                  <Button
                    color="success"
                    size="sm"
                    onClick={() => setShowNewKeyForm(true)}
                    disabled={showNewKeyForm}
                  >
                    <i className="ri-add-line me-1"></i>
                    Add New Key
                  </Button>
                </div>

                {loading ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <div className="accordion" id="themeKeysAccordion">
                    {/* New Key Form Accordion */}
                    {showNewKeyForm && (
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="newKeyHeading">
                          <button
                            className="accordion-button bg-success-subtle text-success"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#newKeyCollapse"
                            aria-expanded="true"
                            aria-controls="newKeyCollapse"
                          >
                            <i className="ri-add-circle-line me-2"></i>
                            <strong>Create New Key</strong>
                          </button>
                        </h2>
                        <div
                          id="newKeyCollapse"
                          className="accordion-collapse collapse show"
                          aria-labelledby="newKeyHeading"
                          data-bs-parent="#themeKeysAccordion"
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label
                                    for="newKeyName"
                                    className="form-label"
                                  >
                                    Key Name{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    id="newKeyName"
                                    type="text"
                                    placeholder="Enter key name"
                                    value={newKey.key}
                                    onChange={(e) =>
                                      setNewKey((prev) => ({
                                        ...prev,
                                        key: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label
                                    for="newKeyDescription"
                                    className="form-label"
                                  >
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    id="newKeyDescription"
                                    type="textarea"
                                    rows="3"
                                    placeholder="Enter description"
                                    value={newKey.description}
                                    onChange={(e) =>
                                      setNewKey((prev) => ({
                                        ...prev,
                                        description: e.target.value,
                                      }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row>
                            <div className="d-flex gap-2">
                              <Button
                                color="success"
                                size="sm"
                                onClick={handleCreateNewKey}
                                disabled={
                                  !newKey.key.trim() ||
                                  !newKey.description.trim()
                                }
                              >
                                <i className="ri-save-line me-1"></i>
                                Create Key
                              </Button>
                              <Button
                                color="secondary"
                                size="sm"
                                onClick={() => {
                                  setShowNewKeyForm(false);
                                  setNewKey({ key: "", description: "" });
                                }}
                              >
                                <i className="ri-close-line me-1"></i>
                                Cancel
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Existing Keys Accordion */}
                    {data?.keys?.map((item, index) => (
                      <div key={item.id || index} className="accordion-item">
                        <h2 className="accordion-header" id={`heading${index}`}>
                          <button
                            className={`accordion-button ${
                              openAccordion === `collapse${index}`
                                ? ""
                                : "collapsed"
                            }`}
                            type="button"
                            onClick={() => toggleAccordion(`collapse${index}`)}
                            aria-expanded={openAccordion === `collapse${index}`}
                            aria-controls={`collapse${index}`}
                          >
                            <div className="d-flex justify-content-between align-items-center w-100 me-3">
                              <div>
                                <i className="ri-key-2-line me-2 text-primary"></i>
                                <strong>{item?.key}</strong>
                              </div>
                              <div className="d-flex align-items-center">
                                {editingKeys[index] && (
                                  <Badge color="warning" className="me-2">
                                    <i className="ri-edit-2-line me-1"></i>
                                    Editing
                                  </Badge>
                                )}
                                {/* <small className="text-muted">
                          {item?.description?.length > 50 
                            ? `${item.description.substring(0, 50)}...` 
                            : item?.description}
                        </small> */}
                              </div>
                            </div>
                          </button>
                        </h2>
                        <Collapse isOpen={openAccordion === `collapse${index}`}>
                          <div className="accordion-body">
                            {editingKeys[index] ? (
                              <div>
                                <div className="mb-3">
                                  <Label
                                    for={`description-${index}`}
                                    className="form-label fw-semibold"
                                  >
                                    Edit Description for "{item?.key}"
                                  </Label>
                                  <Input
                                    id={`description-${index}`}
                                    type="textarea"
                                    rows="4"
                                    value={item.description}
                                    onChange={(e) =>
                                      handleDescriptionChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                    className="form-control"
                                  />
                                </div>
                                <div className="d-flex gap-2">
                                  <Button
                                    color="primary"
                                    size="sm"
                                    onClick={() => handleSave(index)}
                                  >
                                    <i className="ri-save-line me-1"></i>
                                    Save Changes
                                  </Button>
                                  <Button
                                    color="light"
                                    size="sm"
                                    onClick={() => handleCancelEdit(index)}
                                  >
                                    <i className="ri-close-line me-1"></i>
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            ) : (
                              <div>
                                <div className="mb-3">
                                  <h6 className="text-muted mb-2">
                                    Description:
                                  </h6>
                                  <p className="mb-0">
                                    {item?.description ||
                                      "No description available"}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <Button
                                    color="outline-primary"
                                    size="sm"
                                    onClick={() =>
                                      setEditingKeys((prev) => ({
                                        ...prev,
                                        [index]: true,
                                      }))
                                    }
                                  >
                                    <i className="ri-edit-line me-1"></i>
                                    Edit
                                  </Button>
                                  <div className="text-muted small">
                                    <i className="ri-information-line me-1"></i>
                                    Key ID: {item?.id}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </Collapse>
                      </div>
                    ))}
                  </div>
                )}

                {/* Empty State */}
                {!loading &&
                  (!data?.keys || data.keys.length === 0) &&
                  !showNewKeyForm && (
                    <div className="text-center py-5">
                      <div className="mb-3">
                        <i className="ri-key-2-line display-4 text-muted"></i>
                      </div>
                      <h5 className="text-muted">No Keys Found</h5>
                      <p className="text-muted mb-4">
                        Start by creating your first theme option key.
                      </p>
                      <Button
                        color="primary"
                        onClick={() => setShowNewKeyForm(true)}
                      >
                        <i className="ri-add-line me-1"></i>
                        Create First Key
                      </Button>
                    </div>
                  )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ThemeOptionDetail;
